import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Stock from "@/pages/Stock";
import Suppliers from "@/pages/Suppliers";
import SupplierInvoices from "@/pages/SupplierInvoices";
import Invoices from "@/pages/Invoices";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Appointments from "@/pages/Appointments";
import Chat from "@/pages/Chat";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import Quotes from "@/pages/Quotes";
import TimeClock from "@/pages/TimeClock";
import ConversionReport from "@/pages/ConversionReport";
import RecurringExpenses from "@/pages/RecurringExpenses";
import DeliveryNotes from "@/pages/DeliveryNotes";
import QuickInvoice from "@/pages/QuickInvoice";
import PatientStats from "@/pages/PatientStats";

function Protected({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-[#6E7772]" data-testid="loading-screen">
        Cargando…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="citas" element={<Appointments />} />
            <Route path="notificaciones" element={<Notifications />} />
            <Route path="chat" element={<Chat />} />
            <Route path="pacientes" element={<Patients />} />
            <Route path="pacientes/:id" element={<PatientDetail />} />
            <Route path="proveedores" element={<Suppliers />} />
            <Route path="facturas-proveedores" element={<SupplierInvoices />} />
            <Route path="facturas" element={<Invoices />} />
            <Route path="facturas-rapida" element={<QuickInvoice />} />
            <Route path="presupuestos" element={<Quotes />} />
            <Route path="fichaje" element={<TimeClock />} />
            <Route path="conversion" element={<ConversionReport />} />
            <Route
              path="gastos-fijos"
              element={
                <Protected roles={["admin"]}>
                  <RecurringExpenses />
                </Protected>
              }
            />
            <Route
              path="stock"
              element={
                <Protected roles={["admin", "gerente"]}>
                  <Stock />
                </Protected>
              }
            />
            <Route
              path="albaranes"
              element={
                <Protected roles={["admin", "gerente"]}>
                  <DeliveryNotes />
                </Protected>
              }
            />
            <Route
              path="informes"
              element={
                <Protected roles={["admin"]}>
                  <Reports />
                </Protected>
              }
            />
            <Route
              path="estadisticas-pacientes"
              element={
                <Protected roles={["admin", "gerente"]}>
                  <PatientStats />
                </Protected>
              }
            />
            <Route
              path="configuracion"
              element={
                <Protected roles={["admin"]}>
                  <Settings />
                </Protected>
              }
            />
            <Route
              path="usuarios"
              element={
                <Protected roles={["admin"]}>
                  <Users />
                </Protected>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
